import React, { useEffect, useState } from 'react';
import CharacterGrid from '../components/CharacterGrid';
import charactersData from '../data/characters.json';

function Home() {
  const [characters, setCharacters] = useState([]);

  useEffect(() => {
    // In a real scenario, you might fetch from an API.
    setCharacters(charactersData);
  }, []);

  return (
    <div className="home-page">
      <h1>Mortal Kombat Figures</h1>
      <CharacterGrid characters={characters} />
    </div>
  );
}

export default Home;
